import { useMemo } from "react"
import {
  Enum_Safety_Plan_Type_Enum,
  GetRelapsePreventionPlacesByUserQuery,
  useGetRelapsePreventionPlacesByUserQuery,
} from "../generated/graphql"
import { useGraphQLClient } from "./useGraphQLClient"

export type RelapsePreventionPlaces =
  GetRelapsePreventionPlacesByUserQuery["relapse_prevention_places"]

export type RelapsePreventionPlacesByOptionId = Map<
  string,
  RelapsePreventionPlaces
>

/**
 * Fetches a client's active relapse-prevention places and groups them by the
 * safety-plan response option id that owns each place.
 */
export function useRelapsePreventionPlaces(
  userId: string,
  planType: Enum_Safety_Plan_Type_Enum | undefined
) {
  const graphqlClient = useGraphQLClient()

  const { data: relapsePreventionPlacesData } =
    useGetRelapsePreventionPlacesByUserQuery(
      graphqlClient,
      {
        userId,
      },
      {
        enabled: planType === Enum_Safety_Plan_Type_Enum.RelapsePrevention,
      }
    )

  const relapsePreventionPlacesByOptionId = useMemo(() => {
    const placesByOptionId: RelapsePreventionPlacesByOptionId = new Map()
    const relapsePreventionPlaces =
      relapsePreventionPlacesData?.relapse_prevention_places ?? []

    for (const place of relapsePreventionPlaces) {
      const optionId = place.safety_plan_response_option_id.toString()
      const existingPlaces = placesByOptionId.get(optionId) ?? []
      placesByOptionId.set(optionId, [...existingPlaces, place])
    }

    return placesByOptionId
  }, [relapsePreventionPlacesData])

  return { relapsePreventionPlacesByOptionId }
}
